export { default as setErrors } from './setErrors';
export { default as disposeErrors } from './disposeErrors';
import { SnackbarOrigin } from '@material-ui/core/Snackbar';

export type ErrorArguements = {
  message: string;
  name: InitializeableNames;
  anchorOrigin?: SnackbarOrigin;
  [key: string]: any;
};

//Extended Errors
export class FatalError extends Error {
  public readonly name = 'FatalError';
  public status = 400;
  constructor(message: string) {
    super(message);
  }
}
export class SnackError extends Error {
  public severity: 'default' | 'error' | 'warning' | 'information' | 'success' | 'init' = 'error';
  public context = '';
  public autoHideDuration = 8000;
  public anchorOrigin: SnackbarOrigin = {
    vertical: 'bottom',
    horizontal: 'left',
  };
  constructor(message: string) {
    super(message);
  }
}
export class NonFatalError extends SnackError {
  public readonly severity = 'error' as const;
  public readonly autoHideDuration = 8000;
  public readonly context: string;
  constructor({ message, context, ...args }: ErrorArguements) {
    super(message);
    this.context = context;
    Object.assign(this, args);
  }
}

export class UnimportantError extends SnackError {
  public readonly severity = 'default' as const;
  public readonly autoHideDuration = 3000;
  public readonly anchorOrigin = {
    vertical: 'bottom' as const,
    horizontal: 'right' as const,
  };
  public readonly context: string;

  constructor({ message, context, ...args }: ErrorArguements) {
    super(message);
    this.context = context;
    Object.assign(this, args);
  }
}

export class OrganizationNotFound extends Error {
  public readonly name = 'OrganizationNotFound';
  public readonly message = 'No available organization is found.';
  constructor({ message }: ErrorArguements) {
    super(message);
  }
}
export class UserNotFound extends Error {
  public readonly name = 'UserNotFound';
  public readonly message = 'No available User is found.';
  constructor({ message }: ErrorArguements) {
    super(message);
  }
}
export class SigninRequired extends Error {
  public readonly name = 'SigninRequired';
  public readonly message = 'Need to prove your identity';
  constructor({ message }: ErrorArguements) {
    super(message);
  }
}

export type AvailableError =
  | Error
  | FatalError
  | SnackError
  | NonFatalError
  | UnimportantError
  | OrganizationNotFound
  | UserNotFound
  | SigninRequired;

type InitializeableNames =
  | 'NonFatalError'
  | 'UnimportantError'
  | 'OrganizationNotFound'
  | 'UserNotFound'
  | 'VerificationNeeded';
